import type { IFieldDefinition, IRecordTypeDefinition, ModuleStringFallback } from '@platform/core/types';
import type { IPickerOption } from '@platform/ui';
import { hasOptionColours, optionColor, statusColor } from '@platform/core/lib/statusColors';

const COLOURED = new Set(['status', 'priority', 'severity']);

/**
 * Пункти списку вибору (UIUX/field-types/choice-list; прототип fieldItems і dotFor): «Не вказано» першим (крім статусу), підписи
 * мовою інтерфейсу; крапки — для статусу (палітра типу, statusColor), пріоритету, важливості й полів із власними кольорами варіантів
 * (optionColor: колір варіанта → кольори поля → пріоритет/важливість → палітра за порядком).
 */
export function choiceOptions(
  field: IFieldDefinition,
  rt: IRecordTypeDefinition,
  labelOf: (value: string, label: ModuleStringFallback) => string,
  notSet: string,
): IPickerOption[] {
  if (field.key === 'status') {
    return rt.statuses.list.map((s) => ({ value: s.value, label: labelOf(s.value, s.label), dot: statusColor(rt.statuses, s.value, rt.key) }));
  }
  const options = field.options ?? [];
  const coloured = COLOURED.has(field.key) || hasOptionColours(field, rt.key);
  const items = options.map((o) => {
    const dot = coloured ? optionColor(field, o.value, rt.key) : undefined;
    return { value: o.value, label: labelOf(o.value, o.label), ...(dot ? { dot } : {}) };
  });
  return [{ value: '', label: notSet, muted: true }, ...items];
}
